export const LoginTrackingKeys = {
    LOGIN_SIGN_IN_START: 'login_sign_in_start',
    LOGIN_SIGN_IN_COMPLETE: 'login_sign_in_complete',
    LOGIN_ERRORS: 'login_errors',
    LOGIN_SHOW: 'login_show',
    LOGIN_EMAIL_UPDATE: 'login_email_update',
    LOGIN_TAP_REGISTER: 'login_tap_register',
    SMARTLOCK_ERROR: 'smartlock_error',
    LOGIN_YOLO_ERROR: 'login_yolo_error',
    LOGIN_YOLO_CANCEL: 'login_yolo_cancel',
    SMARTLOCK_MEDIATION_REQUEST: 'smartlock_mediation_request',
    LOGIN_SMARTLOCK_SIGN_IN_START: 'login_smartlock_sign_in_start',
    SMARTLOCK_MEDIATION_RESPONSE: 'smartlock_mediation_response',
    PERMISSIONS_IMPRESSION: 'permissions_impression',
    LOGIN_PHONE_CREATE_PASSWORD: 'login_phone_create_password',
    LOGIN_SEND_DATA: 'login_send_data',
    LOGIN_RESEND_CODE: 'login_resend_code',
    LOGIN_RECOVERY_PASS: 'login_recovery_pass',
    CREATE_PASSWORD_SHOW: 'create_password_show',
    CREATE_PASSWORD_SUCCESS: 'create_password_success',
    LOGIN_SHOW_PIN: 'login_show_pin',
    OTP_PROCESSING: 'otp_processing',
    OTP_COMPLETION: 'otp_completion',
    OTP_TIMER_OVER: 'otp_timer_over',
    PHONE_OTP_PAGE_OPEN: 'phone_otp_page_open',
    PHONE_OTP_SUBMIT_SUCCESS: 'phone_otp_submit_success',
    PHONE_OTP_SUBMIT_FAILED: 'phone_otp_submit_failed',
    PHONE_RESEND_CODE: 'phone_resend_code'
};

export const NotificationTrackingKeys = {
    MY_ACCOUNT_NOTIFICATION_PREF_OPEN: 'my_account_notification_pref_open',
    MY_ACCOUNT_NOTIFICATION_PREF_SET: 'my_account_notification_pref_set',
    MYACCOUNT_NOTIFICATION_CHANGE: 'myaccount_notification_change',
    CONFIRM_NOTIFICATION_CHANGE: 'confirm_notification_change'
};

export const ConsentsPageTracking = {
    CONSENT_SHOW: 'consent_show',
    CONSENT_SUCCESSFUL: 'consent_successful',
    CONSENT_CLICK_CANCEL: 'consent_cancel'
};

export const MyAdsFlowType = {
    DELETION: 'deletion',
    MARK_AS_SOLD: 'mark_as_sold'
};

export const MyAdsTracking = {
    AD_EDIT: 'ad_edit',
    AD_LEARN_MORE: 'ad_learn_more',
    AD_MARK_SOLD_CONFIRM: 'ad_mark_sold_confirm',
    AD_MARK_SOLD_SELECT: 'ad_mark_sold_select',
    AD_MARK_SOLD: 'ad_mark_sold',
    AD_POST_NOW: 'ad_post_now',
    AD_REMOVE_COMPLETE: 'ad_remove_complete',
    AD_REMOVE: 'ad_remove',
    AD_REPUBLISH: 'ad_republish',
    AD_UPGRADE: 'ad_upgrade',
    MONET_SUCCESSFUL: 'monet_successful',
    MY_ADS_SEARCH: 'myads_search',
    MYADS_ERROR: 'myads_error',
    MYADS_VIEW_LISTED: 'myads_view_listed',
    MYADS_FILTER: 'myads_filter',
    POSTING_TAP_POST: 'posting_tap_post',
    AD_DEACTIVATE: 'ad_deactivate',
    AD_DEACTIVATE_COMPLETE: 'ad_deactivate_complete',
    AD_REACTIVATE: 'ad_reactivate',
    DOWNLOAD_LEADS: 'myads_tap_download',
    MYADS_PAGINATION_ERROR: 'myads_tap_page_listings_error',
    MYADS_TAP_PAGINATION: 'myads_tap_page_listings',
    MY_ADS_FILTER_CLICKED: 'myads_filter_buttons_clicked',
    MY_ADS_SORT_FILTER_CLICKED: 'myads_sort_filter_applied',
    MYADS_CLEAR_ALL_FILTERS: 'myads_filters_clear_all'
};

export const locationTypes = {
    NEAR_ME: 'near_me',
    PRESET: 'preset',
    DEFAULT: 'default'
};

export const RedirectionTracking = {
    REDIRECTION_CHECK: 'redirection_check'
};

export const AutoLoginTracking = {
    REDIRECTION_AUTOLOGIN_SUCCESSFUL: 'redirection_autologin_successful'
};

export const APP_OPEN = 'app_open';
export const LOGIN_SIGN_IN_COMPLETE = 'login_sign_in_complete';
export const LOGIN_SIGN_OUT = 'login_sign_out';
export const LOCATION_APP_OPEN = 'location_app_open';
export const LOCATION_START = 'location_start';
export const LOCATION_COMPLETE = 'location_complete';
export const MYACCOUNT_SETTINGS = 'myaccount_settings';

export const HOME = 'home'; // Home header location - ok
export const FILTER = 'filter'; // filters location - ok - dynamic parameter desktop
export const SEARCH = 'search'; // header search location or hero search - ok - dynamic parameter desktop
export const POSTING = 'posting'; // posting
export const LISTING = 'listing';
export const OMNIBOX = 'header';
export const CAROUSEL = 'carousel';
export const DEFAULT_FROM = 'default';
export const HEADER_SUGGESTIONS = 'shortcut';

export const VIEW_LISTINGS = 'view_listings';
export const VIEW_LISTINGS_RESULTS_SUMMARY = 'view_listings_results_summary';
export const LISTINGS_RESULTS = 'listings_results';
export const VIEW_LISTINGS_IMPRESSIONS = 'view_listings_impressions';

export const LISTINGS_IMPRESSIONS_CHOSEN_OPTS = {
    HOME: 'home_logo',
    ADPV: 'ad_card',
    FOOTER: 'footer',
    APP_EXIT: 'app_exit'
};

export const VIEW_ITEM = 'view_item';
export const POPULAR_SEARCH = 'popular_search';

export const VIEW_ITEM_TIME = 'view_item_time';

export const LISTINGS_RESULTS_TIME = 'listings_results_time';

export const TYPE_SAVED_HISTORY = 'saved_history';
export const TYPE_TREE = 'tree';
export const TYPE_PARENT_LOCATION = 'parent_location';
export const TYPE_SEARCH = 'search';
export const TYPE_NEAR_ME = 'near_me';
export const TYPE_POPULAR = 'popular';

export const CATEGORY_SELECT_START = 'category_select_start';
export const BROWSE_CATEGORY_SELECT = 'browse_category_select';
export const BROWSE_SUBCATEGORY_SELECT = 'browse_subcategory_select';
export const BROWSE_SUB_CATEGORY_SELECT_COMPLETE = 'browse_sub_category_select_complete';
export const BROWSE_CATEGORY_SHOW = 'browse_category_show';
export const CATEGORY_CHANGE_START = 'category_change_start';
export const CATEGORY_CHANGE = 'category_change';
export const TAP_ALLCATEGORIES = 'tap_allcategories';

export const LISTING_TAP_SELECT_FILTERS = 'listing_tap_select_filters';
export const LISTING_TAP_APPLY_FILTERS = 'listing_tap_apply_filters';
export const LISTING_TAP_REMOVE_FILTERS = 'listing_tap_remove_filters';

export const LISTING_TAP_SELECT_SORT = 'listing_tap_select_sorting';
export const LISTING_TAP_APPLY_SORT = 'listing_tap_apply_sorting';

export const LISTING_TAP_SELECT_VISUALIZATION = 'listing_tap_select_visualization';
export const LISTING_TAP_APPLY_VISUALIZATION = 'listing_tap_apply_visualization';

export const ITEM_TAP_IMAGE = 'item_tap_image';
export const ITEM_TAP_IMAGE_MINIMIZE = 'item_tap_image_minimize';
export const ITEM_TAP_IMAGE_PAGINATION = 'item_tap_image_pagination';
export const ITEM_TAP_REPORT_AD = 'item_tap_report_ad';
export const SOCIAL_TAP_LIKE = 'social_tap_like';
export const SOCIAL_TAP_UNLIKE = 'social_tap_unlike';
export const PROFILE_SHOW = 'profile_show';

export const SEARCH_START = 'search_start';
export const SEARCH_TYPE_EVENT = 'search_type';
export const AUTOCOMPLETE_SUBSTRING = 4;
export const SEARCH_COMPLETE = 'search_complete';
export const SEARCH_TYPE = Object.freeze({
    REGULAR: 'regular',
    SAVED_HISTORY: 'savedhistory',
    AUTOCOMPLETE: 'autocomplete',
    AUTOCOMPLETE_CANCEL: 'autocomplete_cancel',
    POPULAR_SEARCH: 'popular_search'
});

export const EXTENDED_LOCATION = 'extended_location';

export const RelatedAdsKeys = {
    CAROUSEL_LISTING_RESULTS: 'carousel_listings_results',
    CAROUSEL_VIEW_LISTING: 'carousel_view_listings',
    VIEW_ITEM: 'view_item'
};

export const CLICK_DID_YOU_MEAN_HINT = 'did_you_mean_button';
export const SHOW_DID_YOU_MEAN_HINT = 'did_you_mean_show';

export const FILTER_DRAWER_TRACKING = {
    SEE_ALL_FILTERS: 'tap_see_all_filters',
    SEE_LESS_FILTERS: 'tap_see_less_filters',
    CHIP_REMOVED: 'listing_tap_remove_filters',
    QUICK_FILTER_SELECTION: 'listing_tap_select_filters',
    CHOSEN_OPTION: {
        DRAWER: 'drawer',
        SEE_LESS: 'see_less',
        SEE_ALL: 'see_all'
    },
    QUICK_FILTER: 'quick_filter'
};

/* Filters v2 */
export const FILTERSV2_EVENTS = {
    SEARCH_START: 'search_start',
    SEARCH_COMPLETE: 'search_complete',
    APPLIED_FILTERS_SCROLL: 'filter_scroll',
    REMOVE_TAG: 'listing_tap_remove_filters',
    LISTING_TAP_APPLY_FILTERS: 'listing_tap_apply_filters',
    FILTER_PANE_CLOSE: 'filter_pane_close',
    CLEAR_ALL_FILTER: 'clear_all_filter',
    FILTER_PANE_CLOSE_CONFIRMATION: 'filter_pane_close_confirmation',
    FILTER_TYPE_SELECT: 'filter_type_select'
};

export const SELECT_FROM = {
    FILTER_PAGE: 'filter_page',
    LISTING_PAGE: 'listing_page'
};

export const COMMON_PARAMS = {
    CAT_LEVEL: 'category_level',
    SELECT_FROM: 'select_from',
    FILTERS: 'filters',
    FILTER_CNT: 'filter_count',
    SORTING_OPTION: 'sorting_applied',
    VISUAL_OPTION: 'visual_applied',
    INTERACTION: 'filters_interaction'
};

export const CHOSEN_OPTIONS = {
    CANCEL: 'cancel',
    CHANGE: 'change',
    BACK: 'back'
};

export const ADPV_EVENTS = {
    INSPECTION_AREA: 'inspection_area',
    INSPECTION_TAP_CONFIRM: 'inspection_details_to_ad_tap_confirm',
    INSPECTION_TAP_IGNORE: 'inspection_details_to_ad_tap_ignore',
    INSPECTION_TAP_BACK: 'inspection_details_to_ad_tap_back',
    INSPECTION_SUB_AREA: 'inspection_subarea',
    ITEM_TAP_IMAGE_PAGINATION: 'item_tap_image_pagination',
    FEATURE_VIEW_ALL: 'feature_view_all',
    TECHNICAL_REPORT_HEADER: 'technical_report_header',
    TECHNICAL_REPORT_SUBHEADER: 'technical_report_subheader',
    ADPAGE_TOPBAR: 'adpage_topbar',
    ITEM_TAP_INTERESTED: 'item_tap_interested',
    LEAD_FORM_OPEN: 'lead_form_open',
    AD_PAGE_DIALOG_DISMISS: 'ad_page_dialog_dismiss',
    AD_PAGE_T_AND_C: 'ad_page_t_and_c',
    VAS_SERVICE_CLICKED: 'vas_service_clicked',
    SELECT_LOAN_AMOUNT: 'select_loan_amount',
    EMI_OPTION_SELECT: 'emi_option_select',
    IMAGE_360_CTA: 'image_360_cta',
    VIEW_LEAD_IMPRESSION: 'view_lead_impression',
    FINANCE_OPTION_SELECT: 'finance_option_select',
    VIEW_GET_STARTED_PAGE: 'view_get_started_page',
    CONTACT_BUTTON_TAP: 'contact_button_tap'
};

export const CHECKOUT_EVENTS = {
    VIEW_LOCATION: 'view_location',
    RESERVE: 'reserve'
};

export const MYZONE_EVENTS = {
    MY_ZONE_OPEN: 'view_my_zone',
    MY_ZONE_TAP: 'my_zone_tap',
    MY_ZONE_TAP_SECTION: 'my_zone_tap_section'
};

export const CTA_EVENTS = {
    ITEM_TAP_GET_STARTED: 'item_tap_get_started',
    ITEM_TAP_CONTINUE: 'item_tap_continue'
};

export const MEETING_EVENTS = {
    ITEM_TAP_CALL: 'item_tap_call',
    ITEM_TAP_CHAT: 'item_tap_chat',
    ITEM_TAP_PHONE: 'item_tap_phone',
    TEST_DRIVE_CONFIRM: 'test_drive_confirm',
    TAP_OK_CANCEL_MEETING: 'tap_ok_cancel_meeting',
    BOOKING_TAP_RESCHEDULE: 'booking_tap_reschedule',
    BOOKING_DATETIME_CONFIRM: 'booking_datetime_confirm',
    TAP_VIEW_MEETING: 'tap_view_meeting',
    VIEW_DETAILS: 'view_details',
    VIEW_MEETING_PAGE: 'view_meeting_page'
};

export const FLOW_TYPE_EVENTS = {
    item_tap_chat: true,
    item_intent_chat: true,
    chat_inbox: true,
    chat_list_load_start: true,
    item_chat_tap_send_1st_reply: true,
    qcloud_tap_question: true,
    item_chat_tap_send_success: true,
    item_chat_interv_received: true,
    sr_reply_load: true,
    chat_list_displayed: true,
    qcloud_tap_subtopic: true,
    swipe_bottom_sheet_down: true,
    swipe_bottom_sheet_up: true,
    item_chat_tap_send: true,
    view_my_zone: true,
    my_zone_tap: true,
    my_zone_tap_section: true,
    smartlock_mediation_request: true,
    login_smartlock_sign_in_start: true,
    login_show: true,
    login_sign_in_start: true,
    login_sign_in_complete: true
};

export const FORM_ATTRIBUTE_COMPLETE = 'form_attribute_complete';

export const INSPECTED_CARS_BUNDLE = 'ins_cars_bundle';
export const INSPECTED_CARS_BUNDLE_VIEWALL = 'inspected_ad_view_all';
export const BUNDLE_EVENT_TO_RESULTSET_TYPE = {
    [INSPECTED_CARS_BUNDLE]: {
        bundle: 'inspected_ad_bundle',
        page: 'inspected_ad_page',
        home: 'home_inspected_ad_page'
    }
};
export const INSPECTED_CAR_ICN_CLICK = 'inspected_car_icon';
export const CLEVERTAP_USER_PROPERTIES = {
    OLX_USER_ID: 'olx_user_id',
    SESSION_LONG: 'session_long',
    IDENTITY: 'Identity',
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
    OLX_COUNTRY: 'olx_country',
    OLX_COUNTRY_CODE: 'olx_country_code',
    COUNTRY_PREFIX: 'country_prefix',
    REG_DATE: 'reg_date',
    LANG: 'lang',
    DEVICE_LANG: 'device_lang',
    GPLUS_LOGIN: 'gplus_login',
    FB_LOGIN: 'fb_login',
    APPLE_LOGIN: 'apple_login',
    FACEBOOK_ID: 'facebook_id',
    GOOGLE_ID: 'google_id',
    APPLE_ID: 'apple_id',
    TIMEZONE: 'timezone',
    LAST_LOGIN_DATE: 'last_login_date',
    LAST_LOGIN_PLATFORM: 'last_login_platform',
    LAST_LOGIN_MODE: 'last_login_mode',
    IS_BUSINESS: 'is_business',
    IS_PHONE_VISIBLE: 'is_phone_visible',
    PROFILE_PHOTO: 'profile_photo',
    AUTOGENERATED_NAME: 'autogenerated_name',
    DFP: 'dfp',
    PHOTO: 'Photo',
    LAT: 'Lat',
    LONG: 'Long',
    STATE: 'state',
    STATE_ID: 'state_id',
    CITY: 'city',
    CITY_ID: 'city_id',
    LOCALITY: 'locality',
    LOCALITY_ID: 'locality_id',
    REG_PLATFORM: 'reg_platform'
};
export const MOENGAGE_USER_PROPERTIES = {
    OLX_USER_ID: 'uid',
    SESSION_LONG: 'session_long',
    IDENTITY: 'Identity',
    NAME: 'u_n',
    EMAIL: 'u_em',
    PHONE: 'u_mb',
    OLX_COUNTRY: 'olx_country',
    OLX_COUNTRY_CODE: 'olx_country_code',
    COUNTRY_PREFIX: 'country_prefix',
    LANG: 'lang',
    DEVICE_LANG: 'device_lang',
    GPLUS_LOGIN: 'gplus_login',
    FB_LOGIN: 'fb_login',
    APPLE_LOGIN: 'apple_login',
    FACEBOOK_ID: 'facebook_id',
    GOOGLE_ID: 'google_id',
    APPLE_ID: 'apple_id',
    TIMEZONE: 'timezone',
    LAST_LOGIN_DATE: 'last_login_date',
    LAST_LOGIN_PLATFORM: 'last_login_platform',
    LAST_LOGIN_MODE: 'last_login_mode',
    IS_BUSINESS: 'is_business',
    IS_PHONE_VISIBLE: 'is_phone_visible',
    PROFILE_PHOTO: 'profile_photo',
    DFP: 'dfp',
    PHOTO: 'Photo',
    LAT: 'Lat',
    LONG: 'Long',
    STATE: 'state',
    STATE_ID: 'state_id',
    CITY: 'city',
    CITY_ID: 'city_id',
    LOCALITY: 'locality',
    LOCALITY_ID: 'locality_id',
    REG_PLATFORM: 'reg_platform',
    REG_DATE: 'reg_date'
};
export const OLXAUTOS = {
    LANDING_PAGE_OPEN: 'landing_page_open',
    OLXAUTOS_LINKS_TAPPED: 'olxautos_links_tapped',
    OLXAUTOS_FINANCE_SEND_TAPPED: 'hp_finance_tap_send',
    OLXAUTOS_FORM_FIELD_BLUR: 'form_attribute_complete',
    OLXAUTOS_LEAD_FORM_SUBMIT: 'lead_form_submit'
};

export const VAS_TAGS_EVENTS = {
    VAS_TAG_CLICKED: 'vas_tag_clicked'
};

export const VAS_TAGS_HOST = {
    ADPV: 'adpv',
    LISTINGS: 'listings',
    RELATED_AD: 'related_ads'
};
export const HP_OLX_TRACKING = {
    HP_EXCHANGE_BUY: 'exchange_buy_homepage',
    HP_EXCHANGE_SELL: 'exchange_sell_homepage',
    HP_CF_BUY: 'cf_buy_homepage'
};

export const LEAD_FORM_SUBMIT_LISTING = 'lead_form_submit';
export const LEAD_FORM_SUBMIT = 'lead_form_submit';
export const WIDGET_SHOWN = 'widget_shown';

export const GALLERY_INTERMEDIARY_BACK = 'gallery_intermediary_back';

// ADP - gallery navigation event props
export const FLOW_STEP = {
    ADP: 'adp',
    INTERMEDIARY: 'intermediary',
    GALLERY: 'gallery',
    CROSS: 'cross',
    PHONE_BACK: 'phone_back',
    FINANCE_LINK: 'finance_link'
};

export const FLOW_TYPE = {
    ITEM_PAGE: 'itempage',
    FULL_IMAGE_VIEW: 'full_image_view',
    ADPAGE: 'adpage',
    POSTING: 'posting',
    SELLER_RESERVATION: 'seller_reservation',
    SEARCH_PAGE: 'search_page'
};

export const USER_TYPE = {
    FIRST_TIME: 1,
    REPEAT: 2
};

export const FOOTER = {
    HP_FOOTER_IMPRESSION: 'hp_footer_impression'
};

export const CONTACT = {
    CONTACT_BUTTON_TAP: 'contact_button_tap'
};

export const CAR_COMPARE_EVENTS = {
    COMPARE_SHOW: 'car_comparison_show',
    COMPARE_SELECT: 'car_comparison_select',
    COMPARE_UNSELECT: 'car_comparison_unselect',
    COMPARE_POPUP: 'car_comparison_pop_up',
    COMPARE_POPUP_CANCEL: 'car_comparison_pop_up_cancel',
    COMPARE_REMOVE_ALL: 'car_comparison_remove_all',
    COMPARE_ADD: 'car_comparison_add',
    COMPARE_ERROR: 'car_comparison_error'
};

export const CAR_COMPARE_FLOW_STEP = {
    LANDING_PAGE: 'landing_buy',
    LISTING: 'listing',
    ADP: 'adpage',
    POPUP: 'pop_up',
    COMPARE_PAGE: 'car_comparison',
    MY_ZONE: 'my_zone'
};

export const COTF_EVENT_NAME = {
    UNVERIFIED_LEAD_CREATED: 'Unverified_lead_created',
    VERIFIED_LEAD_CREATED: 'Verified_lead_created',
    USER_BLOCKED: 'user_blocked'
};

export const COTF_FIELD_NAME = {
    USE_CASE_1: 'use_case_1',
    USE_CASE_2: 'use_case_2',
    USE_CASE_3: 'use_case_3',
    USE_CASE_4: 'use_case_4',
    USE_CASE_8: 'use_case_8',
    USE_CASE_9: 'use_case_9',
    USE_CASE_10: 'use_case_10'
};

export const LEAD_IMPRESSION_FIELD_NAMES = {
    PHONE: 'phone',
    CHAT: 'chat',
    GET_STARTED: 'get_started',
    I_AM_INTERESTED: 'i_am_interested',
    RESERVE: 'reserve',
    NOTIFY_ME: 'notify_me',
    TEST_DRIVE: 'test_drive',
    WHATSAPP: 'whatsapp'
};

export const VALUATION_COMPLETE = 'valuation_complete';

export const VALUATION_PAGE_OPEN = 'valuation_page_open';

export const SOCIAL_VIEW_NETWORK = 'social_view_network';

export const SOCIAL_PROFILE_SHARE = 'social_profile_share';

export const SELECT_FROM_MY_PROFILE = 'my_profile';

export const SELECT_FROM_OTHER_PROFILE = 'other_profile';

export const SELECT_FROM_PROFILE = 'profile';

export const SELECT_FROM_OWN_FOLLOWERS = 'own_followers';

export const SELECT_FROM_OTHER_FOLLOWERS = 'other_followers';

export const SELECT_FROM_OWN_FOLLOWING = 'own_following';

export const SELECT_FROM_OTHER_FOLLOWING = 'other_following';

export const CLICK_TO_CALL_BANNER_EVENT = 'call_us_click';

export const SELECT_FROM_CAR_CATEGORY = 'car_category';

export const CHOSEN_OPTION_CALL_US = 'call_us';

export const PROMO_CARD_CLICK = 'promo_card_click';

export const CAR_CATEGORY = 'car_category';

export const ESCROW_TRACK = {
    ITEM_TAP_BOOKING_RESERVATION: 'item_tap_booking_reservation',
    ITEM_TAP_VERIFICATION_BANK: 'item_tap_verification_bank',
    ITEM_TAP_PAYMENT_METHOD: 'item_tap_payment_method',
    ESCROW_ITEM_TAP_BUY: 'escrow_item_tap_buy',
    ESCROW_ITEM_TAP_COMPLETE: 'escrow_item_tap_complete',
    TRANSACTION_CONFIRMATION_POPUP: 'transaction_confirmation_popup',
    SELLER_ACTIVATE_BOOKING: 'seller_activate_booking',
    SELLER_TAP_VERIFY_BANK: 'seller_tap_verify_bank',
    SELLER_TAP_SUBMIT_POST: 'posting_tap_submit_post',
    SELLER_TAP_MY_RESERVATION: 'myads_reservation_tab_click',
    SELLER_TAP_COMPLETE: 'myads_reservation_tap_complete',
    SELLER_TAP_COMPLETE_CONFIRM: 'myads_reservation_complete_confirmed',
    SELLER_TAP_WAITING_CONFIRM: 'myads_reservation_tap_confirmation',
    SELLER_POSTING_SUCCESFUL: 'posting_successful_post',
    SELLER_TAP_CONFIRMATION_POPUP: 'seller_tap_confirmation_popup',
    BOOKING: 'booking',
    CLICK_ACTIVATE_BOOKING_CHAT: 'click_activate_booking_chat',
    ITEM_TAP_CHAT_BOOKING: 'item_tap_chat_booking'
};

export const MYBENEFITS_TRACK = {
    MYACCOUNT_MYBENEFITS_CLICKED: 'myaccount_mybenefits_clicked',
    MYBENEFITS_PAGE_OPEN: 'mybenefits_page_open',
    MYBENEFIT_TYPE_CLICK: 'mybenefit_type_click',
    MYBENEFITS_BANNER_CLICK: 'mybenefits_banner_click',
    MYBENEFITS_LIST_PAGE_OPEN: 'mybenefits_list_page_open',
    MYBENEFITS_DETAIL_PAGE_OPEN: 'mybenefits_detail_page_open',
    MYBENEFITS_VOUCHER_CLAIM_START: 'mybenefits_voucher_claim_start',
    MYBENEFITS_PARTNER_CLICK: 'mybenefits_partner_click',
    MYBENEFITS_CONFIRMATION_CLICK: 'mybenefits_confirmation_click',
    MYBENEFITS_VOUCHER_CLAIM_SUCCESS: 'mybenefits_voucher_claim_success',
    MYBENEFITS_VOUCHER_ERROR: 'mybenefits_voucher_error',
    MYBENEFITS_FILE_DOWNLOAD: 'mybenefits_file_download',
    MYBENEFITS_WARRANTY_REVIEW_CLICK: 'mybenefits_warranty_review_click',
    MYBENEFITS_WARRANTY_REVIEW_START: 'mybenefits_warranty_review_start',
    MYBENEFITS_WARRANTY_REVIEW_SUBMITTED: 'mybenefits_warranty_review_submitted',
    MYBENEFITS_WARRANTY_REVIEW_CANCEL: 'mybenefits_warranty_review_cancel',
    MYBENEFITS_WARRANTY_REVIEW_SUCCESS: 'mybenefits_warranty_review_success',
    MYBENEFITS_FORM_OPEN: 'mybenefits_form_open',
    MYBENEFITS_FORM_SUBMIT: 'mybenefits_form_submit',
    MYBENEFITS_INSURANCE_SUCCESS: 'mybenefits_insurance_success'
};
